import { render, staticRenderFns } from "./DecisionAlignement.vue?vue&type=template&id=9a5c7cf8"
import script from "./DecisionAlignement.vue?vue&type=script&lang=js"
export * from "./DecisionAlignement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports